import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';
import Flowplayer from '../components/Flowplayer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getLearningRoom } from '../actions/learningRoomAction';
const $ = window.$;
class Recordedvideo extends Component {
    constructor(props) {
        super(props);
        this.compeletestatus = "";
        this.state = {
            vediocnt: [],
            playersem: null
        };
    }
    getRecordedvideos(data) {
        let trackData = {
            compseq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            divider_id: data.divider_id,
            learner_id: data.learner_id,
            dlr_id: data.dlr_id,
            compo_type: data.compo_type
        };
        Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl + 'recordedvideo/getvideocomponent', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify({
                data,
                learner_id: User.UserId()
            })
        }).then((response) => response.json()).then((responseJson) => {
            this.setState({
                playersem: <Flowplayer playlist={responseJson.videotracks} trackData={trackData} />,
                vediocnt: responseJson.data,
                errmsg: responseJson.errmsg
            });
            setTimeout(() => {
                Common.contentResizeLoad();
                Common.showSmallLeftMenu();
                Common.contentResizeLoad();
                Common.reactLoader("hide");
                //$("html,body").animate({scrollTop : $(".videoscroll").position().top + ($(".videoscroll").outerHeight(true)/2)},300);
                if($(".videoscroll").length>0)
                $("html,body").animate({scrollTop : $(".videoscroll").position().top},300);
                
            }, 200);
        });
    }
    componentDidMount() {
        const {
            data
        } = this.props;
        this.compeletestatus = data.status;
        this.getRecordedvideos(data);
        $(".various").fancybox({
            closeBtn: true,
            maxWidth: 900,
            maxHeight: 600,
            fitToView: true,
            width: '90%',
            height: '90%',
            autoSize: true,
            closeClick: true,
            openEffect: 'none',
            closeEffect: 'none'
        });
        
    }
    componentWillReceiveProps(nextProps) {
        const {
            data
        } = nextProps;
        this.compeletestatus = data.status;
        setTimeout(() => {
            this.getRecordedvideos(data);
        }, 300);
    }
    loading() {
        Common.reactLoader("show", "");
        setTimeout(() => {
            Common.reactLoader("hide");
        }, 200);
    }
    extvideo(externalvideo_link) {
        if (externalvideo_link !== undefined && externalvideo_link.length > 0) {
            let strv = externalvideo_link.map((key, index) => {
                return <ol key={`ms_${index}`} onClick={this.loading()}>Video {index + 1}: <a className="various fancybox fancybox.iframe" href={key}>{key}</a></ol>
            });
            return strv;
        }
    }
    onsubmit() {
        const {
            data
        } = this.props;
        Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl + 'recordedvideo/saveall', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify({
                compseq_id: data.compseq_id,
                lroom_id: data.learning_room_id,
                divider_id: data.divider_id,
                learner_id: User.UserId(),
                dlr_id: data.dlr_id
            })
        }).then((response) => response.json()).then((responseJson) => {
            Common.reactLoader("hide");
            this.props.getLearningRoom();
            if (responseJson.isCompletedFully) {
                this.goToThanksPage();
            } else {
                this.props.switchback(responseJson.type, responseJson.lr_id, responseJson.dlr_id);
            }
        });
    }
    goToThanksPage() {
        const {
            data
        } = this.props;
        this.props.returnthanks({
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "thanks",
            "look_before": data.compseq_id,
            "flowresult": true
        });
    }
    backToComponentList() {
        const {
            data
        } = this.props;
        this.props.switchback('component_list', data.learning_room_id, data.dlr_id);
    }
    submitbuttons() {
        if (this.compeletestatus !== 'completed') {
            return <div id="InActive" className="button">
                <input name="cancel" id="cancel" value="Cancel" className="button-cancel" alt="Cancel" title="Cancel" type="button" onClick={(e) => this.backToComponentList()} />
                <input name="proceed" id="proceed" value="Finish" className="button-accept" alt="Finish" title="Finish" type="button" onClick={(e) => this.onsubmit()} />
            </div>
        } else {
            return "";
        }
    }
    render() {
        let vdata = this.state.vediocnt;
        return (<div className="main-inner">
            <div className="border-box">
                <div className={vdata.base_line ? "title-box" : "title-box tit-new"}>
                    <div title="Recorded Session" className="vc_active_button"></div>
                    <h6>{vdata.videocomponent_name ? vdata.videocomponent_name : ''}</h6>
                    <span>{vdata.base_line ? vdata.base_line : ''}</span>
                </div>
                <section className="scrol" id="smana-scroll-inner">
                    <section className="viewport">
                        <section className="overview">
                            <div className="inner-content">
                                {vdata.isvideoavail === 1 ?
                                    <div className="txtedf">
                                        <div className="lr-gray-box videogray videoscroll">
                                            {this.state.playersem}
                                            <div className="slash_txtLP rgbtn">
                                                <div className="button">
                                                    {this.submitbuttons()}
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.errmsg === '' && <div className="lr-gray-box videogray videohd"> Note: Please click on "HD" on the RHS of your video player and select your best video quality to view.</div>}
                                        <div className="lr-gray-box videogray">
                                            <div className="whitebg"><span className="bluetxt">DISCLAIMER</span><br />
                                                <span>The following videos are not a property of 361DM, and have been suggested to you only to enhance your learning. It is possible that any time later, the owner of the video withdraws it, or the link may get broken, which we cannot fix. In that case, the particular video will not be available for watching any more, and we will not be able to provide a substitute video.</span>
                                            </div>
                                            {(vdata.externalvideo_link!=='') ? 
                                            <div className="whitebg">
                                                <span className="greentxt">Click on the links below to watch the Videos shown in this DLR session</span>
                                                <ul>{this.extvideo(vdata.externalvideo_link)}</ul>
                                            </div> : ""}
                                        </div>
                                    </div>
                                    : <div>{vdata.warning_msg}</div>
                                }

                                {this.state.errmsg !== '' && <div className=" ">{this.state.errmsg}</div>}
                            </div>
                        </section>
                    </section>
                </section>
            </div>
            <div id="dsdpoup-txt4" className="popup"></div>
        </div>);
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getLearningRoom }, dispatch);
}
export default connect(null, mapDispatchToProps)(Recordedvideo);



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Recordedvideo.js